import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
  const toastService = inject(ToastService);
  const authService = inject(AuthService);
  const router = inject(Router);
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log("Error: ", error);
      toastService.showError(error.error?.message || 'An error occurred');
      if (error.status === 401) {
        // Unauthorized - clear auth data and redirect to login
        authService.logout();
        router.navigate(['/auth/login']);
      } else if (error.status === 403) {
        // Forbidden - redirect to unauthorized page
        router.navigate(['/unauthorized']);
      } else if (error.status === 404) {
        // Not Found - redirect to not found page
        router.navigate(['/not-found']);
      }
      // Return the error for further handling
      return throwError(() => ({
        status: error.status,
        message: error.error?.message || 'An error occurred',
        error: error.error
      }));
    })
  );
};
